module.exports = __webpack_public_path__ + "static/media/homeloader5.5b50d449.gif";